import type { AccessRequirement } from '@/lib/access-requirements';
import { ACCESS_REQUIREMENTS } from '@/lib/access-requirements';
import {
  AgendaPage,
  ChangePasswordPage,
  DashboardPage,
  CustomersPage,
  CustomerProfilePage,
  DevPushPage,
  ForbiddenPage,
  ForgotPasswordPage,
  LoginPage,
  OnboardingPage,
  ProfilePage,
  ProfessionalsPage,
  ProductsPage,
  RbacPage,
  RegisterPage,
  ResetPasswordPage,
  SelectCompanyPage,
  ServicesPage,
  SettingsPage,
  SetupPage,
  WalkInQueuePage,
  WorkingHoursPage,
} from '@/routes/lazy-pages';
import type { ReactElement } from 'react';
import { PERMISSIONS } from '@/lib/permissions';

export interface AppRouteConfig {
  path: string;
  element: ReactElement;
  allOf?: readonly string[];
  anyOf?: readonly string[];
  access?: AccessRequirement;
}

export const publicRoutes = [
  { path: '/login', element: <LoginPage /> },
  { path: '/forgot-password', element: <ForgotPasswordPage /> },
  { path: '/reset-password', element: <ResetPasswordPage /> },
  { path: '/change-password', element: <ChangePasswordPage /> },
  { path: '/register', element: <RegisterPage /> },
  { path: '/select-company', element: <SelectCompanyPage /> },
  { path: '/onboarding', element: <OnboardingPage /> },
  { path: '/forbidden', element: <ForbiddenPage /> },
] as const;

export const appRoutes: AppRouteConfig[] = [
  ...(import.meta.env.DEV
    ? [{ path: '/dev/push', allOf: [PERMISSIONS.NOTIFICATION_READ], element: <DevPushPage /> }]
    : []),
  { path: '/setup', element: <SetupPage /> },
  { path: '/dashboard', access: ACCESS_REQUIREMENTS.DASHBOARD, element: <DashboardPage /> },
  { path: '/customers', access: ACCESS_REQUIREMENTS.CUSTOMERS_READ, element: <CustomersPage /> },
  { path: '/customers/:customerId', access: ACCESS_REQUIREMENTS.CUSTOMERS_READ, element: <CustomerProfilePage /> },
  { path: '/agenda', access: ACCESS_REQUIREMENTS.AGENDA_READ, element: <AgendaPage /> },
  { path: '/walk-in-queue', access: ACCESS_REQUIREMENTS.WALK_IN_QUEUE_READ, element: <WalkInQueuePage /> },
  { path: '/services', access: ACCESS_REQUIREMENTS.SERVICES_READ, element: <ServicesPage /> },
  { path: '/products', access: ACCESS_REQUIREMENTS.PRODUCTS_READ, element: <ProductsPage /> },
  {
    path: '/professionals',
    access: ACCESS_REQUIREMENTS.PROFESSIONALS_READ,
    element: <ProfessionalsPage />,
  },
  {
    path: '/working-hours',
    access: ACCESS_REQUIREMENTS.WORKING_HOURS_READ,
    element: <WorkingHoursPage />,
  },
  { path: '/profile', element: <ProfilePage /> },
  { path: '/settings', access: ACCESS_REQUIREMENTS.COMPANY_READ, element: <SettingsPage /> },
  { path: '/rbac', access: ACCESS_REQUIREMENTS.RBAC_MANAGE, element: <RbacPage /> },
];
